export const initIframe = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.m-stage__text iframe').forEach((iframe) => {
            const iframeEl = iframe;
            const src = iframeEl.src;
            if (src.includes('youtube.com') || src.includes('vimeo.com')) {
                const wrapper = document.createElement('div');
                wrapper.classList.add('video-wrapper');
                const parent = iframeEl.parentNode;
                if (parent) {
                    parent.insertBefore(wrapper, iframeEl);
                    wrapper.appendChild(iframeEl);
                }
            }
        });
    });
};
